// extracted by mini-css-extract-plugin
export default {"linkHeight":"wHrF4R95"};